import { render, staticRenderFns } from "./GovSecurity.vue?vue&type=template&id=590b1740&scoped=true"
import script from "./GovSecurity.vue?vue&type=script&lang=js"
export * from "./GovSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b1740",
  null
  
)

export default component.exports